module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc1-04-a67c5c37b192c945f3913a425a6ca884.png";